import { useRecoilCallback } from 'recoil'
import {
  canvasPageIdAtom,
  itemAtomFamily,
  itemIdAtom,
  unsavedChangesAtom,
} from '@/atoms/_editorAtoms'
import {
  editorTextBoxDocumentsSelector,
  editorTextBoxDraftsAtom,
  editorTextBoxPendingDeletesAtom,
} from '@/atoms/editorTextBoxAtoms'
import { editorTextBoxGeometryDraftUpdates } from '@/utils/editor-text-box/editorTextBoxAdapter'
import type { EditorTextBoxDocument } from '@/utils/editor-text-box/editorTextBoxAdapter'

export const useEditorFlushTextBoxGeometry = () =>
  useRecoilCallback(
    ({ snapshot, set }) =>
      async (): Promise<Record<string, EditorTextBoxDocument>> => {
        const pageId = await snapshot.getPromise(canvasPageIdAtom)
        if (!pageId) return {}
        const ids = await snapshot.getPromise(itemIdAtom)
        const items = []
        for (const id of ids) {
          items.push(await snapshot.getPromise(itemAtomFamily(id)))
        }
        const [results, drafts, pendingDeletes] = await Promise.all([
          snapshot.getPromise(editorTextBoxDocumentsSelector(pageId)),
          snapshot.getPromise(editorTextBoxDraftsAtom),
          snapshot.getPromise(editorTextBoxPendingDeletesAtom),
        ])
        const updates = editorTextBoxGeometryDraftUpdates({
          items,
          results,
          drafts,
          pendingDeleteIds: new Set(Object.keys(pendingDeletes)),
        })
        if (Object.keys(updates).length > 0) {
          set(editorTextBoxDraftsAtom, (prev) => ({ ...prev, ...updates }))
          set(unsavedChangesAtom, true)
        }
        return updates
      },
    [],
  )

export default useEditorFlushTextBoxGeometry
